
<template>
    <Modal v-model="modal"
           :title="$t('挂载文件系统')"
           class="rc-add"
           :mask-closable="false"
           @on-cancel="cancel">
        <div class="delete-container">
            <i class="ivu-icon ivu-icon-ios-help-circle"></i>
            <div class="content">
                <p class="desc">{{$t('挂载只支持适用集群类型为【标准专属】【高级自定义专属】的文件系统，自定义专属的文件系统无法进行挂载！')}}</p>
            </div>
        </div>
        <div class="form">
            <Form ref="shareForm"
                  :model="formData"
                  :rules="rules"
                  :label-width="130">
                <FormItem :label="$t('文件系统')+':'"
                          prop="share">
                    <Select v-model="formData.share"
                            style="width:80%">
                        <Option v-for="item in shareList"
                                :key="item.id"
                                :value="String(item.id)">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </div>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('保存中'):$t('确定')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'deletemodal',
    data () {
        return {
            modal: false,
            loading: false,
            sfsid: null,
            formData: {
                share: ''
            },
            resourceId: null,
            hpcId: null,
            shareList: [],
            rules: {
                share: [{ required: true, message: '请选择', trigger: 'change' }]
            }
        }
    },
    methods: {
        openModal (resourceId, hpcId) {
            this.modal = true
            this.hpcId = hpcId
            this.resourceId = resourceId
            this.axios.get(this.urlFormat(API.SURE_MOUNT_PRE, false, [hpcId])).then(res => {
                this.shareList = res
            })
        },
        // 提交
        submit () {
            const name = this.shareList.filter(item => {
                return item.id === Number(this.formData.share)
            })
            this.$refs.shareForm.validate((v) => {
                if (v) {
                    const data = {
                        sfsId: this.formData.share,
                        hpcId: this.hpcId,
                        resourceId: this.resourceId
                    }
                    this.modal = false
                    this.$Modal.confirm({
                        title: this.$t(`确认挂载当前文件系统到资源池${name[0].name}?`),
                        content: this.$t('文件系统挂载后暂时无法进行其他操作。'),
                        onOk: () => {
                            this.axios.post(this.urlFormat(API.REAOURCE_SFS_MOUNT_PRE), data).then(res => {
                                if (res.status === true) {
                                    this.$emit('refresh')
                                }
                            })
                        }
                    })
                }
            })
        },
        cancel () {
            this.$refs.shareForm.resetFields()
            this.shareList = []
            this.updateUrl = null
            this.rowData = null
            this.modal = false
        }
    }
}
</script>
<style lang="less" scoped>
.delete-container {
    // text-align: center;
    padding: 0 0 20px 52px;
    i {
        color: #ff9900;
        font-size: 28px;
        float: left;
    }
    h4 {
        font-size: 14px;
        padding: 3px 0 10px 0;
        font-weight: 500;
    }
    .content {
        padding-left: 38px;
    }
    .desc {
        // color: rgb(239, 66, 53);
        font-size: 12px;
        padding-top: 5px;
    }
}
</style>
